import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@/app/providers/theme-provider';
import { MotionProvider } from '@/app/providers/motion-provider';
import { WorkspaceProvider } from '@/app/providers/workspace-provider';
import { DetailDrawerProvider } from '@/app/providers/detail-drawer-provider';
import { FollowUpProvider } from '@/app/providers/follow-up-provider';
import { ToastProvider } from '@/components/feedback/toast';
import { TooltipProvider } from '@/components/primitives/tooltip';
import { AppRouter } from '@/app/router/app-router';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('找不到 #root 掛載點');

createRoot(container).render(
  <StrictMode>
    {/*
      BrowserRouter 必須在最外層。FollowUpProvider 與 DetailDrawerProvider 會把
      抽屜與面板渲染成 children 的兄弟節點，那些元件裡有 useNavigate，
      放在 Router 之內才不會在開啟的當下 throw。

      TooltipProvider 也要包在這兩層外面：抽屜與面板裡的 IconButton（例如關閉按鈕）
      都需要 Tooltip context，但它們是 children 的兄弟節點、不在 AppShell 底下，
      所以不能只靠 AppShell 自己那層 TooltipProvider。
    */}
    <BrowserRouter>
      <MotionProvider>
        <ThemeProvider>
          <WorkspaceProvider>
            <ToastProvider>
              <TooltipProvider delayDuration={280} skipDelayDuration={200}>
                <FollowUpProvider>
                  <DetailDrawerProvider>
                    <AppRouter />
                  </DetailDrawerProvider>
                </FollowUpProvider>
              </TooltipProvider>
            </ToastProvider>
          </WorkspaceProvider>
        </ThemeProvider>
      </MotionProvider>
    </BrowserRouter>
  </StrictMode>,
);
